import React, { createContext, useContext, type ReactNode } from 'react';

import { type TokenTypes, acceptInvite, checkLogin, clearTokens, exchangeToken } from '@/api';

interface AuthContextType {
    login: (token: string, type: TokenTypes) => Promise<void>;
    loginViaInvite: (token: string, firstName: string, lastName: string) => Promise<void>;
    logout: () => void;
    checkAuth: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType>({
    login: async () => {},
    loginViaInvite: async () => {},
    logout: () => {},
    checkAuth: async () => false,
});

export const useAuth = () => {
    return useContext(AuthContext);
};

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const login = async (token: string, type: TokenTypes) => {
        await exchangeToken(token, type);
    };

    const loginViaInvite = async (token: string, firstName: string, lastName: string) => {
        await acceptInvite(token, firstName, lastName);
    };

    const logout = () => {
        clearTokens();
    };

    const checkAuth = async () => {
        return await checkLogin();
    };

    return <AuthContext.Provider value={{ checkAuth, login, logout, loginViaInvite }}>{children}</AuthContext.Provider>;
};
